import { render, staticRenderFns } from "./invoice_details.vue?vue&type=template&id=d082039a&"
import script from "./invoice_details.vue?vue&type=script&lang=js&"
export * from "./invoice_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports